import { render, staticRenderFns } from "./SettingsMain.vue?vue&type=template&id=0f3d9cd6&scoped=true&"
import script from "./SettingsMain.vue?vue&type=script&lang=js&"
export * from "./SettingsMain.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMain.vue?vue&type=style&index=0&id=0f3d9cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d9cd6",
  null
  
)

export default component.exports